import React, { useContext, useEffect, useState } from "react";
import { Box, Container, CircularProgress } from "@mui/material";
import Header from "../Common/Header";
import Footer from "../Common/Footer";
import ChooseNetwork from "../NetworkSelection/ChooseNetwork";
import { fetchGET } from "../../data/Contentapi";
import { MyContext } from "../../globalContext";
import { useLocation, useNavigate } from "react-router-dom";
import SearchView from "../NetworkSelection/SearchView";
import ViewProviderDetails from "../NetworkSelection/ViewProviderDetails";
import ViewFacilityDetails from "../NetworkSelection/ViewFacilityDetails";
import ErrorFallBackComponent from "../../utils/ErrorFallBackComponent";
import trackPage from "../../data/UsageTracking";
import { getConfig } from "../../loadconfig";
import trackClick from '../../data/ClickTracking.js';
import NotAvailable from "../Common/NotAvailable.js";

const LandingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(false);
  const [networkData, setNetworkData] = useState([]);
  const [selSite, setSelSite] = useState(undefined);
  const [metaData, setMetaData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNotAvailable, setShowNotAvailable] = useState(false);
  const mycontext = useContext(MyContext);
  const {
    languageData,
    setSelectedNetworkData,
    setSelectedSiteData,
    selNetworkg,
    selSiteg,
    showSearch,
    setShowSearchData,
    showSearchResult,
    showDetailsResult,
    selectedForDetails,
    jwtToken,
    setRedirectGenericSiteId
  } = useContext(MyContext);

  const config = getConfig();
  const searchClientSpecificUrl = localStorage.getItem(
    "searchClientSpecificUrl"
  );

  useEffect(() => {
    if (!showSearch) loadFromLocalStorageOrRedirect();
    if (jwtToken) loadNetworkData();
  }, [languageData, showSearch, searchClientSpecificUrl, jwtToken]);

  useEffect(() => {
    if (selNetworkg) {
      setShowSearchData(true);
    }
  }, [selNetworkg, selSiteg]);

  const loadFromLocalStorageOrRedirect = () => {
    const myLocation = location.search;
    
    
    const selNetworkFromLocal = localStorage.getItem("selNetworkg");
    const selSiteFromLocal = localStorage.getItem("selSiteg");
    

    if(myLocation == ""){

    if (selNetworkFromLocal || selSiteFromLocal || searchClientSpecificUrl) {
      setSelectedSiteData(JSON.parse(selSiteFromLocal));
      setSelectedNetworkData(JSON.parse(selNetworkFromLocal));
      setSelSite(JSON.parse(localStorage.getItem("selSiteprop")));
      setShowSearchData(true);
      setError(false);
      setLoading(false);
      navigate(searchClientSpecificUrl, { replace: true });
    }
  }
};

  const getLocale = () => {
    return languageData === "es" ? "ES" : "EN";
  };

  const loadNetworkData = () => {
    const queryParams = new URLSearchParams(location.search);
    setError(false);
      // Get key-value pairs of query parameters
  const queryParamsObject = {};
  for (const [key, value] of queryParams.entries()) {
    if (key.toLowerCase().includes("providersearchconfig")) {
      queryParamsObject["ProviderSearchConfig"] = value;
    }
    if (key.toLowerCase().includes("siteurlsuffix")) {
      queryParamsObject["SiteUrlSuffix"] = value;
    }
    if (key.toLowerCase().includes("siteid")) {
      queryParamsObject["SiteId"] = value;
    }
  }
  
    setLoading(true);
    trackPage("ChooseNetwork", languageData);

    fetchGET(config.NETWORK_CONFIG_URL, queryParamsObject, mycontext, {
      locale: getLocale(),
    })
      .then((data) => {
        handleNetworkDataLoadSuccess(data, queryParamsObject);
      })
      .catch(handleNetworkDataLoadError);
  };

 
const handleNetworkDataLoadSuccess = (data, paramsSet) => {
  let isGenericRedirect = false;
  setMetaData(data.meta);
  setNetworkData(data.netList);
  setSelSite(data.selectedSite);

  const tSelSite = data.selectedSite;
  console.log("paramsSet: " + paramsSet);
  
    if (tSelSite && tSelSite.decommissioned && tSelSite.decommissioned === "Y") {
      handleDecommissionedSite(tSelSite, data.netList);
    }else if (tSelSite && (!tSelSite.siteName || tSelSite.siteName === "") && paramsSet["SiteId"]) {
      //Site id passed, but not client site, so go for generic redirect
      console.log("Site id passed, but no client site, so go for generic redirect");
      handleGenericRedirect(paramsSet["SiteId"], data.netList, false);
    } else {
        finalizeLoading(data, isGenericRedirect);
    }

  setError(false);
  setLoading(false);
};

const handleDecommissionedSite = (tSelSite, netList) => { 

  if (tSelSite.genericRedirectSitedid) {
      handleGenericRedirect(tSelSite.genericRedirectSitedid, netList, true);
  } else if (tSelSite.redirect === "Y") {
      console.log("Redirecting to: " + tSelSite.redirect);
      setSelSite(null);
  } else {
      setShowNotAvailable(true);
      console.log("Redirecting to: Error page :" + tSelSite.redirect);
  }
};

const handleGenericRedirect = (newsiteId, netList, showNotAvailableVal) => {
  console.log("Filtering to generic id: " + newsiteId);
  const selectedNetworks = netList.filter(net => net.siteId === newsiteId);

  if (selectedNetworks.length > 0) {
      console.log("Selected Network: " + selectedNetworks[0].siteId);   
      setSelectedSiteData(null);
      setRedirectGenericSiteId(true);
      setSelectedNetworkData(selectedNetworks);
      trackClick('ChooseNetwork', 'Selected Network', selectedNetworks[0].networkName, languageData);
  } else if (showNotAvailableVal){
      setNetworkData([]);
      setError(false);
      setShowNotAvailable(true);
      console.log("Redirecting to: Error page " );
  }
};

const finalizeLoading = (data, isGenericRedirect) => {
  if (shouldShowSearch(data.selectedSite)) {
      if (!isGenericRedirect) {
          setSelectedSiteData(data.selectedSite);
          setSelectedNetworkData(data.netList);
      }
      setShowSearchData(true);
  }
};
  
  const shouldShowSearch = (selectedSite) => {
    return !showNotAvailable && selectedSite && selectedSite.landingPageindicator === "N";
  };

  const handleNetworkDataLoadError = (errorVal) => {
    console.error(errorVal);
    setError(true);
    setLoading(false);
  };

  const renderDetailsView = (PFFlag) => {
    return PFFlag === "P" ? <ViewProviderDetails /> : <ViewFacilityDetails />;
  };

  const shouldShowChooseNetwork = (
    showSearchResultVal,
    showSearchVal,
    loadingVal,
    selSiteVal
  ) => {
    return (
      !showSearchResultVal &&
      !showSearchVal &&
      !loadingVal &&
      (!selSiteVal ||
        selSiteVal.landingPageindicator === "Y" ||
        selSiteVal.landingPageindicator === "")
    );
  };

  const shouldShowSearchView = (showSearchResultVal, showSearchVal) => {
    return !showNotAvailable && (showSearchResultVal || showSearchVal);

  };

  const renderContent = () => {
    if (metaData.statusCode === "F") {
      return <ErrorFallBackComponent />;
    } else if (showDetailsResult) {
      return (
        <Box alignItems="center">
          {renderDetailsView(selectedForDetails.PFFlag)}
        </Box>
      );
    } else {
      return (
        <>
          {jwtToken && jwtToken !== "" && loading && (
            <Box alignItems="center">
              <CircularProgress data-testid="loading-circle" color="primary" />
            </Box>
          )}

          {shouldShowChooseNetwork(
            showSearchResult,
            showSearch,
            loading,
            selSite
          ) && (
            <ChooseNetwork
              networkDataprop={networkData}
              errorprop={error}
              selSiteprop={selSite}
            />
          )}

          {shouldShowSearchView(showSearchResult, showSearch) && (
            <SearchView selSiteprop={selSite} />
          )}

          {showNotAvailable && (
            <NotAvailable  />
          )}
        </>
      );
    }
  };

  return (
    <>
      <Header />
      <Container className="main-content-area" sx={{ width: "100%", marginY: "2%" }} fixed>
        <Box sx={{ width: "100%" }}>{renderContent()}</Box>
      </Container>
      <Footer />
    </>
  );
};

export default LandingPage;
